import { getGeneralImage, styleHelper } from "../../helpers/commonFunctions";
import useComponentsStore from "../../store/componentsStateStore";
import { useState } from "react";
import { RedirectInfoCardType } from "../../interfaces/redirectInfoCard/RedirectInfoCard.type";
import useAppStore from "../../store/AppStore";


export default function RedirectInfoCard({
  item,
}: {
  item: RedirectInfoCardType;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { continueDraft, isSelectingTab } = useComponentsStore();
  const { isDeviceMobile } = useAppStore()

  const onClickHandler = async () => {
    if (isLoading || isSelectingTab) return;
    try {
      setIsLoading(true);
      await continueDraft(item.redirectBtn.payload);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div
      className={isDeviceMobile ? "vas-mx-3" : "vas-w-100"}
      style={styleHelper({
        backgroundColor: item.backgroundColor,
        border: `1px solid ${item?.borderColor}`,
        borderRadius: "10px",
      })}
    >
      <div className="vas-d-flex vas-align-items-center vas-justify-content-between">
        <div className="vas-mx-2">
          <p
            className="vas-text-18 vas-mx-2 vas-d-flex"
            style={{
              color: item?.textColor,
              fontWeight: item?.style?.bold ? "bold" : "",
            }}
          >
            {item.text}
          </p>
          <button
            className={`vas-btn vas-btn-lg vas-d-flex vas-mb-3 vas-border-radius vas-text-18 vas-px-4 vas-mx-2`}
            style={styleHelper({
              backgroundColor: item.redirectBtn.backgroundColor,
              border: `1px solid ${item.redirectBtn?.borderColor}`,
              color: item?.redirectBtn?.textColor,
              fontWeight: item?.redirectBtn?.style?.bold ? "bold" : "",
            })}
            onClick={onClickHandler}
          >
            {item.redirectBtn.text}
          </button>
        </div>
        <div>
          <img
            className={`vas ${isDeviceMobile ? "vas-mx-2" : "vas-mx-3"}`}
            src={getGeneralImage(item?.icon, "3x")}
            alt=""
            width={70}
            height={70}
          />
        </div>
      </div>
    </div>
  );
}
